import { render, staticRenderFns } from "./EqifyLoader.vue?vue&type=template&id=05604530&scoped=true"
import script from "./EqifyLoader.vue?vue&type=script&lang=ts"
export * from "./EqifyLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05604530",
  null
  
)

export default component.exports